export const SOCKET_MESSAGE_RECEIVE = "SOCKET_MESSAGE_RECEIVE";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const GET_MESSAGES = "GET_MESSAGES";
export const SOCKET_BOARDS_RECEIVE = "SOCKET_BOARDS_RECEIVE";
export const BOARD_READ = "BOARD_READ";
export const GET_GROUP_DATA = "GET_GROUP_DATA";
export const REQUEST_APPOINTMENT = "REQUEST_APPOINTMENT";
export const MANAGE_BOARDS = "MANAGE_BOARDS";
export const GET_CURRENT_THERAPISTS = "GET_CURRENT_THERAPISTS";